import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ICreateComponentRequest, ICreateComponentResponse, ICriteria, IMeasure, IMeasureDetail} from '@models/measures.model';
import { IDropdown } from '@models/dropdown.model';


export const MeasuresActions = createActionGroup({
  source: 'Measures',
  events: {    
    'Measures Component Loaded': emptyProps,

    'Get Measures Success': props<{ measuresData: IMeasure[], totalItems: number}>(),
    'Get Measures Failure': props<{ error: string }>(),

    'Set Measure To Edit': props<{ measure: IMeasure }>(),
    'Clear Measure': emptyProps(),

    'Set Measure Details': props<{ measure: IMeasure, details: ICriteria[] }>(),
  
    'Edit Measure': props<{ measureId: number}>(),
    'Edit Measure Success': emptyProps(),
    'Edit Measure Failure': props<{ error: string }>(),

    'Can View Measure Details': props<{ showMeasureDetails : false}>(),
    'Delete Measure': props<{ measureId: number}>(),
    'Delete Measure Success': emptyProps(),
    'Delete Measure Failure': props<{ error: string }>(),

    'Load Measure Aggregation Types': props<{ measureAggregationTypes : IDropdown[]}>(),
    'Load Measure Aggregation Failure': props<{ error: string }>(),
    
    'Load Measure Types': props<{ measureTypes : IDropdown[]}>(),
    'Load Measure Types Failure': props<{ error: string }>(),

    'Load Criteria Group Types': props<{ criteriaGroupTypes : IDropdown[]}>(),
    'Load Criteria Group Types Failure': props<{ error: string }>(),

    'Click Add New Criteria':  emptyProps(),
    'Add New Criteria Success':  props<{ criteria: ICriteria }>(),
    'Add New Criteria Failure': props<{ error: string }>(),  

    'Update Criteria Success':  props<{ criterias: ICriteria[] }>(),

    'Add New Rule': props<{ criteriaId: number, componentId:number,ruleId: number, sortOrder: number }>(),
    'Add New Rule Success': props<{ details: ICriteria[] }>(),
    'Add New Rule Failure': props<{ error: string }>(),

    'Reorder Criteria List': props<{ previous: number, current: number}>(),
    'Reorder Criteria List Success': props<{ criterias : ICriteria[]}>(),
    'Reorder Criteria List Failure': props<{ error: string }>(),

    'Reorder Rule List': props<{ criteriaId: number, componentId: number, previous: number, current: number }>(),
    'Reorder Rule List Success': props<{ criterias : ICriteria[]}>(),
    'Reorder Rule List Failure': props<{ error: string }>(),

    'Add Measure Component': props<{ request: ICreateComponentRequest, criteriaName: string}>(),
    'Add Measure Component Success': props<{  component : ICreateComponentResponse}>(),
    'Add Measure Component Failure': props<{ error: string }>(),

    'Update Measure Title': props<{ title: string }>(),
    'Update Measure Description': props<{ description: string }>(),
    'Update Measure Ecqm': props<{ ecqm: string }>(),
    'Update Measure Qpp': props<{ qpp: string }>(),
    'Update Measure Type': props<{ measureType: number }>(),
    'Update Measure Priority': props<{ priority: boolean }>(),

    'Click Save Measure':  emptyProps(),
    'Click Save Measure Success':  emptyProps(),
    'Click Save Measure Failure':  props<{ error: string }>(),
  }
  
});
